'use strict';

function DashboardCreditScore() {
  this.id = null;
  this.node = null;
  this.$node = null;
  this.extends = [_AccountController, _ResponsiveLayout, _CreditScoreController, InteractiveCreditScoreDial, CreditScoreColours];
  this.declaredClass = null;

  this.el = {};
  this.promotionsPromise = $.Deferred();

  this.init = function () {
    var _this = this;

    this._super();
    // this._productSettings = new ProductSettings(this.presenter);

    this._portalPresenter = document.getElementById('Portal').mogo();

    // user must view interstitial content once before viewing this page
    // const MEMBER_CONTENTS_KEY = `credit-score-interstitial`;
    // if (!this._productSettings.hasViewedContent(MEMBER_CONTENTS_KEY)) {
    //   this.aborting = true;
    //   this.history.replaceUrl(Product.shortcutMappings[MEMBER_CONTENTS_KEY]);
    // } else {
    this.$node = $(this.node);
    this.el.scoreLayout = this.$node.find('.credit-score-details');
    this.el.scoreStaticContent = $('.credit-score__static_content'); // Accordion, Static Content
    this.el.promoActionContent = $('.crypto-referral-share-wrapper');

    // Load Cross Promotional Loan Offers Banner:
    if (this.presenter.hasAction('account.index_promotions') && !this.presenter.models.promotions) {
      this.presenter.createModel('promotions', { action: 'account.index_promotions' }, function () {
        _this.promotionsPromise.resolve();
      });
    } else {
      this.promotionsPromise.resolve();
    }

    $.when(this.presenter._featureFlagsLoadedPromise, this.promotionsPromise).done(this._onFeatureFlagsLoaded.bind(this));

    // borrowell referral banner:
    var _uuid = this.presenter.getModelProperty('account.uuid');
    this._$referralBannerLink = this.$node.find('.js--protect-referral-link');
    this._$referralBannerLink.attr('href', 'https://borrowell.com/partner/mogo?utm_source=mogo&utm_medium=Referral&utm_campaign=fcs&utm_content=creditscore&utm_term=' + _uuid);
    // }
  };

  this.initAllReady = function () {
    this._super();
    if (!this.aborting) {
      // if (!this.validated) return;
      if (!this.presenter.hasAction('account.get_credit_score')) {
        console.warn('DashboardCreditScore: user missing get_credit_score action.');
        return;
      }

      this.el.interactive_dial = this.$node.find('.js--interactive-credit-score-dial');
      this.el.credit_score_history_graph = this.$node.find('.js--history-graph');
      this._loadCreditScoreModel();
    }
  };

  this._onFeatureFlagsLoaded = function () {
    var pagePromoFound = false;
    var promos = this.presenter.models.promotions;
    if (promos) {
      for (var i = 0; i < promos.promotions.length; i++) {
        var promo = promos.promotions[i];
        if (promo.promotion_type == 'money' && promo.show_promotion) {
          pagePromoFound = true;
          break;
        }
      }
    }

    if (pagePromoFound) {
      this.el.promoBanner = $('<div class="js--cross-promo-banner"></div>').mogo().create('CrossPromo', {
        presenter: this.presenter,
        promoLayoutData: {
          identity_protection: '/member/id-protect/cross-promo',
          money: '/member/loans/preapproval/cross-promo'
        },
        contentfulEntryIdData: {
          identity_protection: '58AHbqLTAA4CIo2a6eiCKK',
          money: '1LI1uZok5qyUS6IUOYw08A'
        },
        promoClassData: {
          identity_protection: 'notification--id-protect',
          money: 'notification--loan-offers'
        }
      });
    }
  };

  // check if index 0 month matches current month and is after batch_pull

  this.onCreditScoreModelReady = function () {
    var _this2 = this;

    this._super();

    this.presenter.addComputedVariable('cs_prev_created_at_month', ['creditScore.credit_scores[1].created_at', 'creditScore.credit_scores[0].created_at'], $.proxy(function (date1, date2) {
      // Set fake previous date if no pref date is provieded
      if ((date1 === '' || date1 === null) && date2 !== '' && date2 !== null) {
        var prevDate = new Date(date2);
        prevDate.setMonth(prevDate.getMonth() - 1);
        date1 = prevDate;
      }

      // Set fake dates if no dates are provieded
      if ((date1 === '' || date1 === null) && date2 === '' && date2 === null) {
        date2 = new Date();
        date1 = date2;
        date1 = date1.setMonth(date1.getMonth - 1);
      }

      return this._getCreditScoreCreatedAtDateMonthAndYear(date1, date2);
    }, this));

    if (this.presenter.models.creditScore.credit_scores[0]) {
      this.presenter.addComputedVariable('cs_created_at_month', ['creditScore.credit_scores[0].created_at'], $.proxy(function (date) {
        return moment(date).format('MMM');
      }, this));
      this.presenter.addComputedVariable('cs_created_at_year', ['creditScore.credit_scores[0].created_at'], $.proxy(function (date) {
        return moment(date).format('YYYY');
      }, this));
      this.presenter.addComputedVariable('cs_created_at_month_year', ['creditScore.credit_scores[0].created_at'], $.proxy(function (date) {
        return moment(date).format('MMM YYYY');
      }, this));
      this.presenter.addComputedVariable('cs_month_year', ['credit_score_month', 'credit_score_year'], $.proxy(function () {
        var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        return months[new Date().getMonth()] + ' ' + new Date().getFullYear();
      }, this));
      this.presenter.addComputedVariable('cs_points_to_next_rating', ['creditScore.credit_scores[0].points_to_next_rating'], $.proxy(function (int) {
        return Formatters.formatSingularPluralString(int, 'point');
      }, this));
    }

    if (this.presenter.models.creditScore.credit_scores[0].score) {
      this.presenter.addComputedVariable('credit_score_change', ['creditScore.credit_scores[0].change'], $.proxy(function (change) {
        if (typeof change !== 'number' && typeof change !== 'string' || ('' + change).indexOf('-') === 0) {
          return change;
        }
        return '+' + change;
      }, this));

      this.el.interactive_dial.mogo().create('InteractiveCreditScoreDial', {
        score: this.presenter.models.creditScore.credit_scores[0].score,
        presenter: this.presenter
      });
    } else {
      this.el.interactive_dial.mogo().create('InteractiveCreditScoreDial', { score: null, presenter: this.presenter });
    }

    if (this._areValidScoresToGraph()) {
      $('#MonthlyCreditScoreGraph').mogo().create('MonthlyCreditScoreGraph', { presenter: this.presenter });
    } else {
      this.el.credit_score_history_graph.parent('.box').hide(); // hide the graph if there are no new scores since Oct 2016
    }

    this._pushAnalytics();
    this._storePageLastViewedOnDate();
    this._legalDisclaimer();
    this.$node.addClass('js--data-loaded ');

    // When credit score data is available, display the dial and details
    // and Add static Accordion content back
    // wait for crypto model
    $.when(this._initializedCryptoUserModelPromise).done(function () {
      _this2.el.scoreLayout.addClass('ui-state__loaded');
      _this2.el.scoreStaticContent.removeClass('ui-state__loading').addClass('ui-state__loaded');
      _this2.el.promoActionContent.removeClass('ui-state__loading').addClass('ui-state__loaded');

      // Required when route has defer_page_load_completed: true
      _this2._portalPresenter.setPageLoadComplete();
    });
    this.registerResponsiveFunction($.proxy(this._stickyCreditScore, this), null, window.mogo.registry.mogoUI.config.mediaQueries.small);
  };

  this._areValidScoresToGraph = function () {
    // Check if any  scores after Oct 2016 exist:
    var today = new Date(); // First Month
    var restrictionDate = new Date(2016, 9, 1); // Oct 1st 2016
    var latestCSscoreDate = new Date(this.presenter.models.creditScore.credit_scores[0].created_at);
    // Check if any scores in last 5 months exist:
    var monthsSinceLatestPull = this.monthsAgo(latestCSscoreDate, today);
    return latestCSscoreDate >= restrictionDate && monthsSinceLatestPull < 6;
  };

  this._stickyCreditScore = function () {
    var rating = this.presenter.models.creditScore.credit_scores[0].rating;
    var score = this.presenter.models.creditScore.credit_scores[0].score;

    // -add appropriate classes to the sticky credit score

    if (score === null || typeof score === 'undefined' || score.length < 1) {
      $('.cs-sticky-score').addClass('no-rating');
    } else {
      $('.cs-sticky-score').css({
        'border-bottom': '4px solid ' + this.calculateScoreColor(score)
      });
    }

    // get bottom position of dial
    var dial = this.$node.find('.js--interactive-credit-score-dial');

    if (dial.length > 0) {
      var dialOffset = dial.offset().top + dial.height() - 100;
      $(window).on('scroll.attachCreditScore', function () {
        if ($(window).scrollTop() >= dialOffset) {
          $('.cs-sticky-score').addClass('score-fixed');
        } else {
          $('.cs-sticky-score').removeClass('score-fixed');
        }
      });
    }
  };

  this._legalDisclaimer = function () {
    $('.js--legal-disclaimer', this.node).mogo().create('LegalDisclaimer', {
      legal: $('[data-legal]:visible', this.node),
      presenter: this.presenter,
      otherLegal: ['disclaimer.equifaxCreditScoreStandard']
    });
  };

  this._pushAnalytics = function () {
    this.analytics.pushEvent('virtual-page-view');
    this.analytics.pushEvent('dashboard-home-creditscore-view', {
      CreditScore: [this.presenter.models.account.credit_score],
      'Credit Rating': [this._creditRating],
      CreditUpdate: [this.presenter.models.account.monthly_credit_check_opt_in, this.presenter.models.account.monthly_credit_check_originator]
    });
  };

  this._storePageLastViewedOnDate = function () {
    if (this.presenter.hasAction('account.edit_member')) {
      this.presenter.performAction('account.edit_member', {
        credit_score_viewed_at: moment.utc().format('YYYY-MM-DD HH:mm:ss z')
      });
    }
  };

  this.monthsAgo = function (d1, d2) {
    var months = void 0;
    months = (d2.getFullYear() - d1.getFullYear()) * 12;
    months -= d1.getMonth();
    months += d2.getMonth() + 1;
    return months <= 0 ? 0 : months;
  };

  this.destroy = function () {
    this._abortLoadCreditScoreModel();
    this.presenter.removeComputedVariable('credit_score_change');
    this.presenter.removeComputedVariable('cs_created_at_month');
    this.presenter.removeComputedVariable('cs_created_at_year');
    this.presenter.removeComputedVariable('cs_created_at_month_year');
    this.presenter.removeComputedVariable('cs_month_year');
    this.presenter.removeComputedVariable('cs_prev_created_at_month');
    $(window).off('scroll.attachCreditScore');
  };
}